import { DataProxy } from 'apollo-cache'
import { ShareListItemFragment, ShareListItemFragmentDoc } from 'gqlTypes'
import { dataIdFromObject } from 'graphql/apolloClient'
import { ErrorHandler } from 'modules/tracing'

interface ReadShareListItemFromCache {
  cache: DataProxy
  id: string
}

export const readShareListItemFromCache = ({
  cache,
  id,
}: ReadShareListItemFromCache) => {
  try {
    return (
      cache.readFragment<ShareListItemFragment>({
        id: dataIdFromObject({
          __typename: 'Share',
          identifier: id,
        }) as string,
        fragment: ShareListItemFragmentDoc,
        fragmentName: 'ShareListItem',
      }) || undefined
    )
  } catch (e) {
    //readFragment can throw errors if there isn't sufficient data in the cache
    ErrorHandler.ignore(
      e,
      'by design, we ignore errors when using readShareFromCache util'
    )
    return undefined
  }
}

interface WriteShareListItemToCache {
  cache: DataProxy
  share: ShareListItemFragment
}

export const writeShareListItemToCache = ({
  cache,
  share,
}: WriteShareListItemToCache) =>
  cache.writeFragment<ShareListItemFragment>({
    id: dataIdFromObject(share) as string,
    fragment: ShareListItemFragmentDoc,
    fragmentName: 'ShareListItem',
    data: share,
  })
